import { TLightingSystemsState } from './types'

export default {
  loadingComponents: true,
  loadingTimeseries: true,
  loadingOperationStates: true,
  systems: [],
  consumption: []
} as TLightingSystemsState
